import axios from '@/axios'
import API from '@/API'

const PREFIX = 'permission_temp'

export default {
  datatable(params) {
    return axios.get(`${API.endpoint}/${PREFIX}/datatable`, {
      params: params
    })
  },
  detail(id) {
    return axios.get(`${API.endpoint}/${PREFIX}/detail/${id}`)
  },
  store(data) {
    return axios.post(`${API.endpoint}/${PREFIX}/add`, data)
  },
  update(id, data) {
    return axios.post(`${API.endpoint}/${PREFIX}/update/${id}`, data)
  },
  delete(id) {
    return axios.post(`${API.endpoint}/${PREFIX}/delete/${id}`)
  },
  isDefault(privilege) {
    return axios.get(`${API.endpoint}/${PREFIX}/is_default/${privilege}`)
  }
}